import NextLink from "next/link";
import { Card, CardBody, CardHeader, CardFooter, Link, Image, Heading, Text } from "@chakra-ui/react";
import { useStoryblokLink } from "hooks";
import { useTranslations } from "contexts/LocalizationContext";
import { ArrowRightIcon } from "styles/icons";
import isEmpty from "modules/storyblok/adapters/RichtextAdapter/utils/isEmpty";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import type { APRCardProps } from "../APRCards.d";

export const APRCard = ({ title, description, link, imgSrc }: APRCardProps) => {
  const translations = useTranslations();
  const resolvedCardLink = useStoryblokLink(link);

  return (
    <Card w="277px" variant="elevated" overflow="hidden" mb={8} px={3} py={4} mt={{ base: 6, md: 8 }}>
      <CardHeader>
        <Image src={imgSrc} w="40px" objectFit="cover" />
      </CardHeader>
      <CardBody>
        <Heading variant="h4" as="h4" fontWeight="bold" mt={3} mb={4}>
          {title}
        </Heading>
        {!isEmpty(description) && (
          <RichtextAdapter content={description} customStyles={{ paragraph: { fontSize: "md" } }} />
        )}
      </CardBody>
      <CardFooter>
        {link && (
          <Link as={NextLink} href={resolvedCardLink}>
            <Text fontSize="lg" color="primary.500" fontWeight="medium">
              {translations("read_more")} <ArrowRightIcon boxSize={4} ml={2} />
            </Text>
          </Link>
        )}
      </CardFooter>
    </Card>
  );
};
